import CampaignDetail from "./Detail";
import CampaignList from "./List";

export { CampaignList, CampaignDetail };